import { AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { FilesService } from '@services/files/files.service';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterContentChecked, AfterViewInit {
  
  title = 'app'
  public currentVersion: string
  public latestVersion: string
  public hideReleaseNotes: boolean
  public isNavCollapsed: boolean = false
  public whitelabel: string = "default"

  constructor(
    private authenticationService: AuthenticationService,
    private cdref: ChangeDetectorRef,
    private router: Router,
    private dialog: NgbModal,
    private filesService: FilesService,
    private spinner: NgxSpinnerService
  ) {
    this.spinner.show();
    this.sendNavigationEventsToGoogleAnalytics();
    this.getWhiteLabel();
    this.isNavCollapsed = localStorage.getItem('isNavCollapsed') === 'true'
  }

  ngOnInit(): void {
    console.log(`Welcome to`);
    console.log(`%c
 ██████╗██╗   ██╗██████╗  ██████╗ ███████╗    ██████╗ ██████╗ ███╗   ██╗███╗   ██╗███████╗ ██████╗████████╗
██╔════╝██║   ██║██╔══██╗██╔═══██╗██╔════╝   ██╔════╝██╔═══██╗████╗  ██║████╗  ██║██╔════╝██╔════╝╚══██╔══╝
██║     ██║   ██║██████╔╝██║   ██║███████╗   ██║     ██║   ██║██╔██╗ ██║██╔██╗ ██║█████╗  ██║        ██║   
██║     ██║   ██║██╔══██╗██║   ██║╚════██║   ██║     ██║   ██║██║╚██╗██║██║╚██╗██║██╔══╝  ██║        ██║   
╚██████╗╚██████╔╝██████╔╝╚██████╔╝███████║██╗╚██████╗╚██████╔╝██║ ╚████║██║ ╚████║███████╗╚██████╗   ██║   
 ╚═════╝ ╚═════╝ ╚═════╝  ╚═════╝ ╚══════╝╚═╝ ╚═════╝ ╚═════╝ ╚═╝  ╚═══╝╚═╝  ╚═══╝╚══════╝ ╚═════╝   ╚═╝
`, `color: #f6a500`);
    
    if (this.authenticationService.isUserAuthenticated()) {
      this.authenticationService.sendAuthStateChangeNotification(true);
    } else {
      this.authenticationService.tryRefreshingTokens();
    }
  }

  ngAfterViewInit() {
    this.spinner.hide();
  }

  getWhiteLabel() {
    const subdomain = window.location.host.split('.')[0]
    if (subdomain && !subdomain.includes('localhost')) {
      this.filesService.whitelabelExists(subdomain).subscribe(isExisting => {
        if (isExisting) {
          this.whitelabel = subdomain
          localStorage.setItem('whitelabel', this.whitelabel)
          document.getElementsByTagName('body')[0].setAttribute('data-whitelabel', this.whitelabel)
          this.appendWhiteLabel()
        } else {
          localStorage.removeItem('whitelabel')
        }
      })
    } else {
      localStorage.removeItem('whitelabel')
    }
  }
  
  appendWhiteLabel() {
    const head = document.getElementsByTagName('head')[0]
    const link = document.createElement('link')
    const href = `https://cubosgeneralstorage.blob.core.windows.net/whitelabel-storage/${this.whitelabel}/styles.css`
    link.setAttribute('rel', 'stylesheet')
    link.setAttribute('href', href)
    link.setAttribute('whitelabel', this.whitelabel)
    head.append(link)
  }

  ngAfterContentChecked() {
    // this.cdref?.detectChanges(); what does this do?
  }

  sendNavigationEventsToGoogleAnalytics() {
    if (document.cookie.includes('cookie_consent=all_cookies')) {
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          gtag('config', 'G-8HDWDWPV32', { 'page_path': event.urlAfterRedirects });
        }
      })
    }
  }
}
